import { useTranslation } from 'react-i18next';

export const CHATBOT_NAME = "CHATBOT";
export const ASSISTANT_CHATBOT_NAME = "ASSISTANT";
export const USER_NAME = "USER";

export const useAppConstants = () => {
    const { t } = useTranslation();

    return {
        DEFAULT_CONVERSATION_TITLE_PREFIX: t('constants.conversationPrefix'),
        DEFAULT_OCR_BATCH_TITLE_PREFIX: t('constants.ocrBatchPrefix'),
        DATA_SOURCE_TITLE_PREFIX: t('constants.dataSourcePrefix'),
        CONVERSATION_GROUP_SECTIONS: {
            PINNED: t('constants.pinned'),
            TODAY: t('constants.today'),
            YESTERDAY: t('constants.yesterday'),
            LAST_7_DAYS: t('constants.lastSevenDays'),
            OLDER: t('constants.older'),
        }
    };
};